import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { API, get } from 'utils/api';
import { createReducer } from 'utils/redux';
import { logError } from 'utils/log';

const { VARIABLE_PAYMENTS } = API.END_POINTS;

const VARIABLE_PAYMENTS_LOADING = 'subcampaign-variable-payments/VARIABLE_PAYMENTS_LOADING';
const VARIABLE_PAYMENTS_LOADED = 'subcampaign-variable-payments/VARIABLE_PAYMENTS_LOADED';
const VARIABLE_PAYMENTS_RESET = 'subcampaign-variable-payments/VARIABLE_PAYMENTS_RESET';

import type { Action, Dispatch, ThunkAction, VariablePayments } from 'types';

const initialState = {
  variablePayments: {},
  isLoading: false
};

const setLoadingStatus = (type: string, status: boolean): Action => ({
  type,

  payload: {
    status
  }
});

const variablePaymentsLoaded = (type: string, data: VariablePayments): Action => ({
  type,

  payload: {
    data
  }
});

export const fetchVariablePayments = (campaignId: number, subcampaignId: number): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(setLoadingStatus(VARIABLE_PAYMENTS_LOADING, true));

  try {
    const url = VARIABLE_PAYMENTS.getSubcampaignVariablePayments(campaignId, subcampaignId);
    const response = (await get(url)) as { data: VariablePayments };

    dispatch(variablePaymentsLoaded(VARIABLE_PAYMENTS_LOADED, response.data));
  } catch (e) {
    dispatch(setLoadingStatus(VARIABLE_PAYMENTS_LOADING, false));
    logError(e);
  }
};

export const resetVariablePayments = (): Action => ({
  type: VARIABLE_PAYMENTS_RESET
});

export default createReducer<any, any>('subcampaignVariablePayments', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [VARIABLE_PAYMENTS_RESET]: (state) => ({
    ...state,
    variablePayments: {}
  }),
  [VARIABLE_PAYMENTS_LOADED]: (state, { data }) => ({
    ...state,
    variablePayments: data || {},
    isLoading: false
  }),
  [VARIABLE_PAYMENTS_LOADING]: (state, { status }) => ({
    ...state,
    isLoading: status
  })
});
